import { useNavigate } from "react-router-dom";
import {useState} from 'react';
import Styles from './Styles.jsx';
import SiteText from './SiteText.jsx';

const DropDown = () => {
    const items = Object.values(SiteText.NavBar.Bottom.Services.DropDownMenuText);
    const navigate = useNavigate();

    return <div className="w-96">
        {items.map((item, index) => {
            return <div key={index}>
                <button 
                    className={index === (items.length - 1) ? `${Styles.NavBar.DropDownMenu.MenuItem} + rounded-b-lg` : Styles.NavBar.DropDownMenu.MenuItem}
                    onClick={() => navigate(SiteText.SitePaths.Service + item.replaceAll(" ", "-").toLowerCase())}    
                >
                    {item}    
                </button>
                <div className={index === (items.length - 1) ? "" : Styles.NavBar.DropDownMenu.Septerator}></div>
            </div>
        })}
    </div>
}

const DropDownMenu = (props) => {
    const [isShown, setIsShown] = useState(false);
    const {displayText, className} = props;

    return <div className="flex flex-col items-center justify-center size-full">
        <div
            className="relative size-full"
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
        >
            <button
                className = {className}
            >
                {displayText}
            </button>
            {isShown && (
                <div className="absolute top-full left-0">
                    <DropDown />
                </div>
            )}
        </div>
    </div>
}

export default DropDownMenu;